import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=effc9f78&"
import script from "./BasicLayout.vue?vue&type=script&lang=js&"
export * from "./BasicLayout.vue?vue&type=script&lang=js&"
import style0 from "./BasicLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('effc9f78')) {
      api.createRecord('effc9f78', component.options)
    } else {
      api.reload('effc9f78', component.options)
    }
    module.hot.accept("./BasicLayout.vue?vue&type=template&id=effc9f78&", function () {
      api.rerender('effc9f78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/layouts/BasicLayout.vue"
export default component.exports